import AccessDenied from "../Errors/AccessDenied";
import NotFound from "../Errors/NotFound";
import NoRoles from "../Errors/NoRoles";

export default [
  {
    name: "404",
    parent: "root",
    url: "/404",
    component: NotFound,
    allowAnonymous: true
  },
  {
    name: "403",
    parent: "root",
    url: "/403",
    component: AccessDenied,
    allowAnonymous: true
  },
  {
    name: "noRoles",
    parent: "root",
    url: "/no-roles",
    component: NoRoles,
    allowAnonymous: true
  }
];



// WEBPACK FOOTER //
// ./src/components/Router/errorStates.js